import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable, OnInit } from '@angular/core';
import { environment } from '@env/environment';
import { CookieService } from 'ngx-cookie-service';
import { Observable, of } from 'rxjs';
import { tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class CallsLogsService implements OnInit {
  api_url = environment.baseIP + environment.apiPrefix;
  access_token: any;
  private callsCache: any[] | null = null;
  constructor(
    private httpClient: HttpClient,
    private _cookieService: CookieService,
  ) {
    this.access_token = this._cookieService.get("access_token");
  }

  ngOnInit(): void {

  }
  //start note 
  userResetPassword(formData: any): Observable<any> {
    const headers = new HttpHeaders({
      Authorization: 'Bearer ' + this.access_token
    });

    return this.httpClient.post(
      `${this.api_url}user/reset-password`,
      formData,
      { headers: headers }
    );
  }


  //end note

  //for call log
  addCallLogLead(formData, organization_id): Observable<any> {
    const headers = new HttpHeaders({
      organizationId: organization_id.toString(),
      Authorization: 'Bearer ' + this.access_token
    });

    return this.httpClient.post(
      `${this.api_url}call-log/create`,
      formData,
      { headers: headers }
    ).pipe(
      tap(() => this.clearCallsCache())
    );
  }
  updateCallLogLead(formData, organization_id): Observable<any> {
    const headers = new HttpHeaders({
      organizationId: organization_id.toString(),
      Authorization: 'Bearer ' + this.access_token
    });
    return this.httpClient.post(
      `${this.api_url}call-log/update`,
      formData,
      { headers: headers }
    ).pipe(
      tap(() => this.clearCallsCache())
    );
  }
  getCallLogList(payload, organization_id): Observable<any> {
    if (this.callsCache) {
      return of(this.callsCache);
    }
    const headers = new HttpHeaders({
      organizationId: organization_id.toString(),
      Authorization: 'Bearer ' + this.access_token
    });

    return this.httpClient.post(
      `${this.api_url}call-log/list`,
      payload,
      { headers: headers }
    ).pipe(
      tap(res => {
        this.callsCache = res
      })
    );
  }
  viewCallLogListByID(payload, organization_id): Observable<any> {
    const headers = new HttpHeaders({
      organizationId: organization_id.toString(),
      Authorization: 'Bearer ' + this.access_token
    });

    const params = new HttpParams()
      .set('id', payload.toString());

    return this.httpClient.get<any>(
      `${this.api_url}call-log/view`,
      { headers, params }
    );
  }

  deleteCalllogLead(payload: number, organization_id: number): Observable<any> {
    const headers = new HttpHeaders({
      organizationId: organization_id.toString(),
      Authorization: 'Bearer ' + this.access_token
    });

    const params = new HttpParams()
      .set('id', payload.toString());

    return this.httpClient.delete<any>(
      `${this.api_url}call-log/delete`,
      { headers, params }
    ).pipe(
      tap(() => this.clearCallsCache())
    );
  }
  clearCallsCache() {
    this.callsCache = null;
  }
  //end call log

  private contactsCache: any[] | null = null;
  getContactListService(payload, organization_id): Observable<any> {
    // if (this.contactsCache) {
    //   return of(this.contactsCache);
    // }
    console.log("get body:", payload, organization_id);
    const headers = new HttpHeaders({
      organizationId: organization_id.toString(),
      Authorization: 'Bearer ' + this.access_token
    });

    return this.httpClient.post(
      `${this.api_url}contact/list`,
      payload,
      { headers: headers }
    )
    //.pipe(
    //   tap(res => {
    //     this.contactsCache = res
    //   })
    // );
  }


}